import { PremiumReceivablesReceiptRecord } from "entities/UIModel/PremiumReceivablesReceiptRecord";

export const SAMPLE_RECEIPT_RECORDS: PremiumReceivablesReceiptRecord[] = [
  {
    uniqueIdentifier: "AR-001",
    AgentID: "401582",
    AgentName: "Lone Star Title Insurance",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/26/2026",
    ReceiptTypeCode: "REC",
    ReceiptNumber: "REC-2026-04-1318",
    ReceiptAmount: -24180.00,
    GLPRINumber: "4310",
    GLSubNumber: "02",
    GLDeptNumber: "200",
    BankAccountNumber: "****7710",
    IsCancel: false,
    Comments: "Receipt applied to April balance",
  },
  {
    uniqueIdentifier: "AR-002",
    AgentID: "331042",
    AgentName: "Heritage Title Group",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/25/2026",
    ReceiptTypeCode: "JE",
    ReceiptNumber: "JE-2026-04-1301",
    ReceiptAmount: -48340.20,
    GLPRINumber: "4100",
    GLSubNumber: "03",
    GLDeptNumber: "305",
    BankAccountNumber: "****3092",
    IsCancel: false,
    Comments: "April month-end true-up",
  },
  {
    uniqueIdentifier: "AR-003",
    AgentID: "880412",
    AgentName: "Coastal Title",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/24/2026",
    ReceiptTypeCode: "CHK",
    ReceiptNumber: "CHK-2026-04-1248",
    ReceiptAmount: -14470.50,
    GLPRINumber: "5500",
    GLSubNumber: "01",
    GLDeptNumber: "100",
    BankAccountNumber: "****4821",
    IsCancel: false,
    Comments: "Check payment received",
  },
  {
    uniqueIdentifier: "AR-004",
    AgentID: "880412",
    AgentName: "Coastal Title",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/23/2026",
    ReceiptTypeCode: "JE",
    ReceiptNumber: "JE-2026-04-1267",
    ReceiptAmount: 0.00,
    GLPRINumber: "4200",
    GLSubNumber: "01",
    GLDeptNumber: "100",
    BankAccountNumber: "****4821",
    IsCancel: true,
    Comments: "Voided - stop-payment issued by agent",
  },
  {
    uniqueIdentifier: "AR-005",
    AgentID: "456723",
    AgentName: "Watson Title, LLC",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/22/2026",
    ReceiptTypeCode: "JE",
    ReceiptNumber: "JE-2026-04-1182",
    ReceiptAmount: -18000.00,
    GLPRINumber: "4200",
    GLSubNumber: "02",
    GLDeptNumber: "200",
    BankAccountNumber: "****7710",
    IsCancel: false,
    Comments: "Partial April adjustment",
  },
  {
    uniqueIdentifier: "AR-006",
    AgentID: "220889",
    AgentName: "Elevate Title Agency of Michigan",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/22/2026",
    ReceiptTypeCode: "JE",
    ReceiptNumber: "JE-2026-04-1184",
    ReceiptAmount: -4180.00,
    GLPRINumber: "5500",
    GLSubNumber: "02",
    GLDeptNumber: "200",
    BankAccountNumber: "****7710",
    IsCancel: false,
    Comments: "April-to-date reconciliation",
  },
  {
    uniqueIdentifier: "AR-007",
    AgentID: "770213",
    AgentName: "Mountain Land Title",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/21/2026",
    ReceiptTypeCode: "JE",
    ReceiptNumber: "JE-2026-04-1015",
    ReceiptAmount: -18100.00,
    GLPRINumber: "5500",
    GLSubNumber: "03",
    GLDeptNumber: "200",
    BankAccountNumber: "****7710",
    IsCancel: true,
    Comments: "Voided - duplicate entry from batch import",
  },
  {
    uniqueIdentifier: "AR-008",
    AgentID: "112233",
    AgentName: "Summit Peak Title",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/20/2026",
    ReceiptTypeCode: "CHK",
    ReceiptNumber: "CHK-2026-04-1201",
    ReceiptAmount: -9800.00,
    GLPRINumber: "5500",
    GLSubNumber: "01",
    GLDeptNumber: "100",
    BankAccountNumber: "****9910",
    IsCancel: false,
    Comments: "",
  },
  {
    uniqueIdentifier: "AR-009",
    AgentID: "556677",
    AgentName: "Riverbend Title Company",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/19/2026",
    ReceiptTypeCode: "REC",
    ReceiptNumber: "REC-2026-04-1289",
    ReceiptAmount: -3200.00,
    GLPRINumber: "4310",
    GLSubNumber: "01",
    GLDeptNumber: "200",
    BankAccountNumber: "****7710",
    IsCancel: false,
    Comments: "Late payment, penalty waived",
  },
  {
    uniqueIdentifier: "AR-010",
    AgentID: "998877",
    AgentName: "Golden State Escrow & Title",
    AccountingPeriod: "04/2026",
    ReceiptDate: "04/18/2026",
    ReceiptTypeCode: "CHK",
    ReceiptNumber: "CHK-2026-04-1177",
    ReceiptAmount: -14200.00,
    GLPRINumber: "5500",
    GLSubNumber: "01",
    GLDeptNumber: "100",
    BankAccountNumber: "****2231",
    IsCancel: false,
    Comments: "",
  },
];
